import type { at } from '../generated/Beans';
type Institution = at.sense.portlets.saf.virtualvisitpatient.model.Institution;
import { create } from 'zustand';
import {
  getHospitalsByRegionId,
  getInstitutionsByRegionId,
  getRegions
} from '../communication/ajax';
import { PortletStoreApi } from '../App';
import { produce } from 'immer';

export interface RegionInstitutionStore {
  regions: Institution[];
  institutions: Institution[];
  hospitals: Institution[];
  loading: boolean;
  loadRegions: () => Promise<void>;
  loadInstitutions: (regionId: string) => Promise<void>;
  loadHospitals: (regionId: string) => Promise<void>;
}

export const [useRegionInstitutionStore] = create<RegionInstitutionStore>(
  set => ({
    loading: false,
    regions: [],
    institutions: [],
    hospitals: [],
    loadRegions: async () => {
      console.log('loadRegions');
      try {
        set(state => (state.loading = true));
        const resp = await getRegions({
          url: PortletStoreApi.getState().url
        });
        set(state => (state.regions = resp.data));
      } finally {
        set(state => (state.loading = false));
      }
    },
    loadInstitutions: async (regionId: string) => {
      console.log('load institutions');
      try {
        set(state => (state.loading = true));

        const resp = await getInstitutionsByRegionId({
          url: PortletStoreApi.getState().url,
          regionId: regionId
        });
        set(
          produce(state => {
            state.institutions = [...resp.data];
          })
        );
      } finally {
        set(state => (state.loading = false));
      }
    },
    loadHospitals: async (regionId: string) => {
      console.log('load institutions');
      try {
        set(state => (state.loading = true));
        const resp = await getHospitalsByRegionId({
          url: PortletStoreApi.getState().url,
          regionId: regionId
        });
        set(
          produce(state => {
            state.hospitals = [...resp.data];
          })
        );
      } finally {
        set(state => (state.loading = false));
      }
    }
  })
);
